import { Box, Typography } from "@mui/material";


export default function InConstruction() {
    return (
        <>
{/* top banner */}
      <Box sx={{ mb: 2, textAlign: "center" }}>
        <Typography sx={{ fontSize: 28, color: "red", fontWeight: "bold" }}>
         Diese Seite ist in Bearbeitung, bald Eröffnung. Benutzunung nur für Tests!
        </Typography>
      </Box>
      </>
    );
}
